<template>
  <div>
    <!-- 头部 -->
    <Top></Top>
    <div class="w">
      <div class="login">
        <router-link to="/">
          <img src="../../assets/img/logo.png" alt />
        </router-link>
      </div>
    </div>
    <div class="w error">
      <div class="img-box">
        <img src="../../assets/img/error.png" alt />
      </div>
    </div>
    <router-link to="/" class="fanhui"> トップページへ </router-link>
    <!-- 尾部 -->
    <Foot></Foot>
  </div>
</template>
<script>
import Top from "../../components/head/Top";
import Foot from "../../components/foot/Foot";
export default {
  data() {
    return {};
  },
  methods: {},
  components: {
    Top,
    Foot,
  },
};
</script>
<style lang='scss' scoped>
.login {
  margin: 15px 0 60px;
  a {
    display: block;
    width: 200px;
    height: 150px;
    img {
      width: 200px;
      height: 150px;
    }
  }
}
.error {
  transform: translate(0, -100px);
  .img-box {
    width: 566px;
    height: 342px;
    margin: 0 auto 60px;
    overflow: hidden;
    img {
      transform: translate(0, 100px);
      width: 566px;
      height: 342px;
    }
  }
}
.fanhui {
  display: block;
  width: 150px;

  height: 40px;
  margin: 0 auto 100px;
  text-align: center;
  line-height: 40px;
  color: #333;
  background-color: #F3C622;
  font-size: 16px;
  font-weight: 700;
}
</style>